<pv-resident-toolbar backAction="custom" [title]="toolbarTitle()" (back)="goBack()" />

<loading-indicator [running]="loading$ | async" />

<div class="content">
	@if (task$ | async; as task) {
		@if (task.recordType !== "WOUNDCARE") {
			<ic-tasks-detail-view
				[formConfig]="form$ | async"
				[permissions]="['MEDAPP.CARE.ADMINISTER_CARE']"
				[task]="task"
				(create)="onCreate($event)"
			/>
		} @else {
			<ic-tasks-detail-view
				[breadcrumbs]="breadcrumbs()"
				[formConfig]="form$ | async"
				[permissions]="['MEDAPP.CARE.ADMINISTER_WOUNDCARE']"
				[task]="task"
				(create)="onCreate($event)"
			/>
		}
	}
</div>
